import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import globalButtonStyles from '../../styles/ButtonGradient.module.css';
import styles from './CoachAcceptModal.module.css';

const CoachAcceptModal = ({ isOpen, onClose, coachRequests, onAccept, onDecline, loading }) => {

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.overlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={styles.modal}
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <button className={styles.closeButton} onClick={onClose} aria-label="Close modal">
              <FiX />
            </button>
            <h2 className={styles.heading}>Coach Requests</h2>
            <div className={styles.requestsList}>
            {loading ? (
              <div className={styles.spinner}></div>
            ) : (coachRequests && coachRequests.length === 0) ? (
              <p>No pending requests.</p>
              ) : (
                coachRequests.map((request) => (
                  <div key={request._id} className={styles.requestCard}>
                    <p>{request.coach.firstName} {request.coach.lastName} ({request.coach.user.email})</p>
                    <div className={styles.buttonRow}>
                      <button
                        type="button"
                        className={`${globalButtonStyles.button} ${styles.acceptButton}`}
                        onClick={() => onAccept(request._id)}
                      >
                        Accept
                      </button>
                      <button
                        type="button"
                        className={`${globalButtonStyles.button} ${styles.declineButton}`}
                        onClick={() => onDecline(request._id)}
                      >
                        Decline
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CoachAcceptModal;